
import Vue, { PropType } from 'vue'
import { TranslateResult } from 'vue-i18n'
import SiteFancyInput from '~/components/site/FancyInput.vue'
import HoverCircleButton from '~/components/_general/HoverCircleButton.vue'

export default Vue.extend({
  name: 'SitePasswordInput',
  components: { HoverCircleButton, SiteFancyInput },
  model: {
    prop: 'password',
  },
  props: {
    password: {
      type: String,
      required: true,
    },
    placeholder: {
      type: String as PropType<TranslateResult>,
      default(): TranslateResult {
        return this.$t('Enter a password')
      },
    },
    inputName: {
      type: String,
      default: 'private-password',
    },
    disabled: {
      type: Boolean,
    },
  },
  data() {
    return {
      showPassword: false,
    }
  },
  methods: {
    inputEvent(event: Event) {
      this.$emit('input', (event.target as HTMLInputElement).value)
    },
  },
})
